export const isValidString = (str: string): string => {
  str = str.replace(/\s+/g, ' ')
  const regex = /^[a-zA-Z\s]+$/
  return regex.test(str) ? str : str.replace(/[^a-zA-Z\s]/g, '')
}

export const orderCase = (str: string): string => {
  return str
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')
}

export const isValidMail = (str: string): string => {
  return str
    .replace(/\s+/g, '')
    .trim()
    .replace(/[^a-zA-Z0-9@+.]/g, '')
    .toLowerCase()
}
